import { useEffect, useState } from 'react';

/**
 * Returns true after the browser is idle (or after `timeout` ms as a fallback).
 * Use this to defer mounting of non-critical components (ads, off-screen widgets)
 * so they don't compete with first paint / interactivity.
 */
export const useIdleMount = (timeout = 1500): boolean => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return;
    let cancelled = false;
    const mark = () => {
      if (!cancelled) setReady(true);
    };

    const w = window as any;
    if (typeof w.requestIdleCallback === 'function') {
      const id = w.requestIdleCallback(mark, { timeout });
      return () => {
        cancelled = true;
        if (typeof w.cancelIdleCallback === 'function') w.cancelIdleCallback(id);
      };
    }

    const t = window.setTimeout(mark, timeout);
    return () => {
      cancelled = true;
      window.clearTimeout(t);
    };
  }, [ready, timeout]);

  return ready;
};
